import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {TokenInterceptor} from './core/interceptors/token.interceptor';
import {SimpleMaskModule} from '@initru/ngx-ion-simple-mask';
import {ToolbarComponentModule} from './components/ui/toolbar/item.module';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {HttpErrorInterceptor} from './core/interceptors/httpError.interceptor';
import {ButtonComponentModule} from './components/ui/button/item.module';
import {MbscModule} from '@mobiscroll/angular';
import {AngularFireModule} from '@angular/fire/compat';
import {AngularFireMessagingModule} from '@angular/fire/compat/messaging';
import {RoundProgressModule} from 'angular-svg-round-progressbar';
import { AngularFireAnalyticsModule, ScreenTrackingService } from '@angular/fire/compat/analytics';
import {MenuComponentModule} from 'app/components/ui/menu/item.module';
import { ChatInputFieldModule } from "app/components/ui/chat/item.module";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    MbscModule,
    BrowserModule,
    CommonModule,
    HttpClientModule,
    HttpClientJsonpModule,
    IonicModule.forRoot({
      mode: 'md',
      scrollAssist: false
    }),
    AppRoutingModule,
    ToolbarComponentModule,
    AppRoutingModule,
    SimpleMaskModule,
    FormsModule,
    ReactiveFormsModule,
    RoundProgressModule,
    // ServiceWorkerModule.register('combined-sw.js', {
    //   enabled: environment.production,
    //   // Register the ServiceWorker as soon as the application is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    ButtonComponentModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    AngularFireAnalyticsModule,
    MenuComponentModule,
    ChatInputFieldModule
  ],
  providers: [
    DatePipe,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ScreenTrackingService
    // ScreenTrackingService,
    // UserTrackingService,
    // Auth
    // {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler,
    // },
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
